// extracted by mini-css-extract-plugin
export default {"container":"claimCommunicatorForm_container__4AR7T"};